import styled from 'styled-components'

export const TabBar = styled.div`
  position: relative;

  .container-mobile-tab-nav {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    background-color: ${ (props) => props.theme.colors.weiss };
    z-index: ${ (props) => props.theme.zIndices.overlay };
  }

  .arrow-icon-mobile {
    transform-origin: center center;
    transition: 0.2s;
    position: absolute;
    right: 15px;
    top: calc(50% - 10px);
    z-index: ${ (props) => props.theme.zIndices.modal };
    transform: rotate(${ (props) => (props['style-open'] ? '180deg' : '0deg') });
    color: ${ (props) => props.theme.colors['aok-gruen'] };
  }
`

export const TabMobileSelect = styled.div`
  cursor: pointer;
  padding: 5px 40px 10px 10px;

  &.selected {
    background-color: ${ (props) => props.theme.colors['hintergrund-prio2'] };
  }
`
export const TabItem = styled.div`
  -webkit-print-color-adjust: exact;
  color-adjust: exact;
  background-color: ${ (props) => props.theme.colors['hintergrund-prio2'] };
  padding: 5px 40px 10px 10px;
  box-shadow: 1px 2px 1px 0 rgba(0, 0, 0, 0.13);

  min-height: 50px;
  margin: 10px 0 20px;
  display: none;
  align-items: center;
  cursor: pointer;
  position: relative;

  &:after {
    content: ' ';
    position: absolute;
    left: calc(50% - 5px);
    width: 10px;
    height: 10px;
    bottom: -5px;
    transform: rotate(45deg);
    -webkit-print-color-adjust: exact;
    color-adjust: exact;
    background-color: ${ (props) => props.theme.colors['hintergrund-prio2'] };
    box-shadow: 1px 2px 1px 0 rgba(0, 0, 0, 0.13);
  }

  @media print {
    border: 1px solid ${ (props) => props.theme.colors['hintergrund-prio2'] };
  }

  .treatments {
    color: ${ (props) => props.theme.colors['panel-inner-border'] };
  }

  @media ${ (props) => props.theme.breakpoints.devices.min.md } {
    display: flex;
    padding: 0;
    background-color: transparent;
    box-shadow: none;
    margin: 10px 0;

    &:after {
      display: none;
    }
  }

  &.selected {
    display: flex;
  }
`

export const SelectedTabIndicator = styled.div`
  opacity: ${ (props) => props.styles.opacity };
  position: absolute;
  left: 0;
  top: ${ (props) => props.styles.top }px;
  height: ${ (props) => props.styles.height }px;
  -webkit-print-color-adjust: exact;
  color-adjust: exact;
  background-color: ${ (props) => props.theme.colors['hintergrund-prio2'] };
  width: calc(100% + 15px);
  transition: opacity 0.15s ease-out, top 0.2s ease-out;
  margin-left: -30px;
  display: none;

  &:after {
    left: 100%;
    top: 0;
    content: ' ';
    position: absolute;
    border-style: solid;
    border-width: ${ (props) => props.styles.height / 2 }px 0
      ${ (props) => props.styles.height / 2 }px 30px;
    border-color: transparent transparent transparent
      ${ (props) => props.theme.colors['hintergrund-prio2'] };
  }

  @media ${ (props) => props.theme.breakpoints.devices.min.md } {
    display: block;
  }
`
